export const COINS = [
  { symbol: 'BTC',  name: 'Bitcoin',    color: '#F7931A' },
  { symbol: 'ETH',  name: 'Ethereum',   color: '#627EEA' },
  { symbol: 'XRP',  name: 'Ripple',     color: '#00AAE4' },
  { symbol: 'SOL',  name: 'Solana',     color: '#9945FF' },
  { symbol: 'BNB',  name: 'BNB',        color: '#F3BA2F' },
  { symbol: 'ADA',  name: 'Cardano',    color: '#0D1E4A' },
  { symbol: 'DOGE', name: 'Dogecoin',   color: '#C2A633' },
  { symbol: 'DOT',  name: 'Polkadot',   color: '#E6007A' },
];

export const NETWORKS: Record<string, string[]> = {
  BTC:  ['Native'],
  ETH:  ['ERC20'],
  XRP:  ['Native'],
  SOL:  ['Native'],
  BNB:  ['BEP20', 'ERC20'],
  ADA:  ['Native'],
  DOGE: ['Native'],
  DOT:  ['Native'],
  USDT: ['ERC20', 'TRC20', 'BEP20'],
};

export const COIN_EMOJIS: Record<string, string> = {
  BTC: '₿', ETH: 'Ξ', XRP: '✕', SOL: '◎',
  BNB: 'B', ADA: '₳', DOGE: 'Ð', DOT: '●',
};

export const LEVERAGE_OPTIONS = [1, 2, 5, 10, 20, 50, 100];

export const DURATION_OPTIONS = [
  { label: '15 min',  value: 15 },
  { label: '30 min',  value: 30 },
  { label: '1 hour',  value: 60 },
  { label: '4 hours', value: 240 },
  { label: '1 day',   value: 1440 },
  { label: '7 days',  value: 10080 },
];
